// extracted by mini-css-extract-plugin
export default {"inputWrapper":"index_inputWrapper__dLTd0","bordered":"index_bordered__TgbSM","label":"index_label__nJzYM"};